import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Booking API
export const bookingAPI = {
  create: async (bookingData) => {
    const response = await apiClient.post('/bookings/', bookingData);
    return response.data;
  },
  
  checkAvailability: async (stayUnitId, checkInDate, checkOutDate) => {
    const response = await apiClient.get('/bookings/availability', {
      params: { stayUnitId, checkInDate, checkOutDate },
    });
    return response.data;
  },
  
  getBooking: async (bookingId) => {
    const response = await apiClient.get(`/bookings/${bookingId}`);
    return response.data;
  },
};

// Contact API
export const contactAPI = {
  submit: async (contactData) => {
    const response = await apiClient.post('/contact/', contactData);
    return response.data;
  },
};

// Feedback API
export const feedbackAPI = {
  submit: async (feedbackData) => {
    const response = await apiClient.post('/feedback/', feedbackData);
    return response.data;
  },
};

// Stay Units API
export const stayUnitsAPI = {
  getAll: async () => {
    const response = await apiClient.get('/stay-units/');
    return response.data;
  },
  
  getOne: async (unitId) => {
    const response = await apiClient.get(`/stay-units/${unitId}`);
    return response.data;
  },
};

export default apiClient;
